















































import { Component, Emit, Prop, Vue } from 'vue-property-decorator';
import PriceDiscountOptionProjection from '@/types/projections/PriceDiscountOptionProjection';
import TextField from '@/components/form/TextField.vue';
import UploadField from '@/components/form/UploadField.vue';
import Button from '@/components/Button.vue';
import SelectField from '@/components/form/SelectField.vue';
import ButtonToggleField from '@/components/form/ButtonToggleField.vue';
import NewTranslation from '@/components/i18n/NewTranslation.vue';
import i18next from 'i18next';
import CheckboxField from '@/components/form/CheckboxField.vue';
import { namespace } from 'vuex-class';

const I18nModule = namespace('i18n');

@Component({
  components: {
    NewTranslation,
    TextField,
    UploadField,
    Button,
    SelectField,
    CheckboxField,
    ButtonToggleField,
  },
})
export default class BookingOptionOverlay extends Vue {
  @Prop({ required: false, type: Object })
  public option!: PriceDiscountOptionProjection;

  public values: { [fieldName: string]: any } = {};

  @I18nModule.Getter
  public locale!: string;

  @Emit()
  public close(): void {
    this.values = {};
  }

  public getLabel(field: any): string {
    if (this.locale === 'de') {
      return field.label_de;
    }
    return field.label_en;
  }

  public submit(): void {
    const priceDiscountIds = Object.keys(this.values);
    if (priceDiscountIds.length === 0) {
      return;
    }

    let allMandatoriesProvided = true;
    const discountAttributes = this.option.attributes;
    Object.keys(discountAttributes).forEach(attr => {
      const isMandatory = discountAttributes[attr].mandatory;
      if (isMandatory && allMandatoriesProvided) {
        allMandatoriesProvided = typeof this.values[attr] !== 'undefined';
      }
    });

    if (allMandatoriesProvided) {
      if (
        this.values.disabilityMarkers &&
        (this.values.disabilityMarkers as string[]).includes('B') &&
        this.values.chaperoneIsHuman
      ) {
        this.showInfo(
          i18next.t('booking.optionDialog.chaperone.dialog.title'),
          i18next.t('booking.optionDialog.chaperone.dialog.body'),
          () => {
            this.$emit('submit', this.values);
          }
        );
      } else {
        this.$emit('submit', this.values);
      }
    }
  }

  public showInfo(title: string, message: string, submit: () => void): void {
    const overlayData: any = {
      title,
      message,
    };

    if (submit) {
      overlayData.submit = submit;
    }

    this.$store.commit('openOverlay', {
      overlayName: 'Info',
      overlayData: overlayData,
    });
  }

  public getFields(): any {
    if (!this.option) {
      return [];
    }

    const attributes = this.option.attributes;
    const fieldIds = Object.keys(attributes);
    const fields = fieldIds
      .filter(id => id !== 'matchOnlyIf')
      .map((id, i) => ({
        id,
        ...attributes[id],
      }));
    return fields;
  }

  public getComponentByFieldType(fieldType: 'document' | 'string' | 'select' | 'buttonToggle'): string {
    switch (fieldType) {
      case 'document':
        return 'UploadField';
      case 'select':
        return 'SelectField';
      case 'buttonToggle':
        return 'ButtonToggleField';
      case 'string':
      default:
        return 'TextField';
    }
  }

  public fieldOptionsWithDefault(
    options: Array<{ label: string; value: string }>
  ): Array<{ label: string; value: string }> {
    if (!options) {
      return [];
    }
    return [{ label: i18next.t('booking.optionDialog.select.default.label'), value: '' }, ...options];
  }

  public get shouldShowChaperonePetCheckbox(): boolean {
    return this.values.disabilityMarkers && this.values.disabilityMarkers.indexOf('B') !== -1;
  }
}
